import React from "react";
import classNames from "classnames";
import Cookies from "js-cookie";
import throttle from "lodash.throttle";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";

const SkipToButton = () => {
  const { t } = useTranslation("common");
  const visibiltyScrollLimit = 300;
  const [isVisible, setIsVisible] = React.useState(false);
  const [hasBeenShown, setHasBeenShown] = React.useState(false);
  const userCookieScrollPos = React.useRef(Number(Cookies.get("progress")));

  // Go to stored position on click
  const handleClick = () => {
    userCookieScrollPos.current = Number(Cookies.get("progress"));
    window.scroll({
      top: userCookieScrollPos.current,
      left: 0,
      behavior: "smooth",
    });
  };

  const handleVisibility = () => {
    const scrollY =
      document.documentElement.scrollTop || document.body.scrollTop || 0;

    // Hide button if user has scrolled passed limit, and don't show again
    if (isVisible && scrollY > visibiltyScrollLimit) {
      setIsVisible(false);
      setHasBeenShown(true);
    }

    // Show button if user has not scrolled passed limit and stored position is higher than scroll position
    if (
      !isVisible &&
      !hasBeenShown &&
      scrollY < visibiltyScrollLimit &&
      userCookieScrollPos.current > visibiltyScrollLimit
    ) {
      setIsVisible(true);
    }

    // If user has gotten option to skip and returns to top, we reset progress
    if (hasBeenShown && scrollY < visibiltyScrollLimit) {
      Cookies.set("progress", "0");
    }
  };

  const handleScroll = React.useCallback(throttle(handleVisibility, 100), [
    isVisible,
    setIsVisible,
    hasBeenShown,
    setHasBeenShown,
  ]);

  React.useEffect(() => {
    document.addEventListener("scroll", handleScroll);
    handleVisibility();

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll, handleVisibility]);

  return (
    <Button
      className={classNames(
        "pubr-skip-to-btn",
        isVisible && "pubr-skip-to-btn--visible"
      )}
      aria-hidden={!isVisible}
      onClick={() => handleClick()}
    >
      {t("skipToLast")}
    </Button>
  );
};

export { SkipToButton };
